import { render } from "./ReferentialAccess.vue?vue&type=template&id=635b918d&scoped=true"
import script from "./ReferentialAccess.vue?vue&type=script&lang=js"
export * from "./ReferentialAccess.vue?vue&type=script&lang=js"

import "./ReferentialAccess.vue?vue&type=style&index=0&id=635b918d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635b918d"],['__file',"src/components/admin/ReferentialAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "635b918d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('635b918d', __exports__)) {
    api.reload('635b918d', __exports__)
  }
  
  module.hot.accept("./ReferentialAccess.vue?vue&type=template&id=635b918d&scoped=true", () => {
    api.rerender('635b918d', render)
  })

}


export default __exports__